<template>
  <v-card>
    <v-card-title>Create category</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="category.name"
                :rules="[v => !!v || 'Name is required']"
                label="Name" 
                required autofocus></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-autocomplete
                v-model="category.parent"
                :items="['India', 'China']"
                label="Parent"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 sm6>
              <v-switch
                v-model="category.is_credit"
                :label="'Is Credit'"
              ></v-switch>
            </v-flex>
            <v-flex xs6 sm6>
              <v-switch
                v-model="category.show_in_report"
                :label="'Show in report'"
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 sm12>
              <v-textarea
                v-model="category.notes"
                rows="2"
                auto-grow
                clearable
              >
                <template v-slot:label>
                  <div>
                    Note <small>(optional)</small>
                  </div>
                </template>
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <loading-state text="" :state="state"></loading-state>
      <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="$emit('input', false)">Close</v-btn>
      <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validate"
      ><span v-if="category.key">Save</span><span v-else>Create</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Utils from "@/utils"
import { DataState } from "@/state"
import { Category } from "@/models/category"
export default {
  props: {
    category: {
      default: ()=>{return Category.newEmpty()},
      type: Object
    }
  },
  data: () => ({
    state: DataState.newNotInit(),
    valid: true,
    lazy: true,
  }),

  // mounted () {
  //   if(!this.category) {
  //     this.category = Category.newEmpty()
  //   }
  // },

  // computed: {
  //   priceHint () {
  //     if (!this.account.currency) {
  //       return ''
  //     }

  //     let res =  Utils.price(this.account.opening_balance, this.account.currency)
  //     return res
  //   }
  // },

  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        if(this.category.key) {
          this.saveCategory(false)
        } else {
          this.saveCategory(true)
        }
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    saveCategory (create) {
      this.valid = false
      this.state.changeToLoading()
      let fn = 'create'
      if (!create) {
        fn = 'save'
      }
      this.category[fn]().then((response) => {
        // this.category = Category.newEmpty()
        this.state.changeToLoaded()
        if(create) {
          this.$emit('created', response)
        } else {
          this.$emit('saved', response)
        }
        // this.$refs.form.reset()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
  },
}
</script>